import { render, staticRenderFns } from "./CryptoSearch.vue?vue&type=template&id=0ebd8160&"
import script from "./CryptoSearch.vue?vue&type=script&lang=ts&"
export * from "./CryptoSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports